export enum FlexAlign {
  ALIGN_ITEM_START = "align-items-start",
  ALIGN_ITEM_END = "align-items-end",
}
